import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const columns = [
  { field: "exchangeSymbol", headerName: "Exchange Symbol",width:150 },
  { field: "closePrice", headerName: "closePrice", type: "number",width:120 },
  {
    field: "highestPrice",
    width:150,
    headerName: "Highest Price",

    type: "number",
  },
  {
    field: "lowestPrice",
    width:140,
    headerName: "Lowest Price",
    type: "number",
  },
  {
    field: "tradingVolume",
    width:200,
    headerName: "Trading Volume",

    type: "number",
  },
];

export default function DataTable({ rows }) {
  const [pageSize, setPageSize] = React.useState(5);

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: 400,
        width: "100%",
        
       
      }}
    >
      <DataGrid
      
        sx={{ bgcolor: "white",cursor:'pointer' }}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rows={rows}
        rowsPerPageOptions={[5, 10, 20, 40, 100]}
        pagination
        columns={columns}
        onCellClick={(params, e) => {
          console.log(params);
          navigate(`/cryptos/X:${params.row.exchangeSymbol}`);
        }}
      />
    </Box>
  );
}
